import request from '@/router/axios';

export const getList = (params) => {
  return request({
    url: '/api/produce/device-alarm-records/wagontippler/select/page',
    method: 'post',
    params
  })
}

export const getOverview = (params) => {
  return request({
    url: '/api/produce/device-alarm-records/wagontippler/statistics/overview',
    method: 'post',
    params
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/produce/device-alarm-records/select/id',
    method: 'get',
    params: {
      id
    }
  })
}

export const exportExcel = (params) => {
  return request({
    url: '/api/produce/device-alarm-records/wagontippler/export/excel',
    method: 'post',
    params,
    responseType: 'blob'
  })
}

export const alarmHandling = (data) => {
  return request({
    url: '/api/produce/device-alarm-records/alarmHandling',
    method: 'post',
    data
  })
}

export const batchAlarmHandling = (ids, data) => {
  return request({
    url: '/api/produce/device-alarm-records/batchAlarmHandling',
    method: 'post',
    params: { ids },
    data
  })
}

export const oneClickAlarmHandling = (data) => {
  return request({
    url: '/api/produce/device-alarm-records/wagontippler/oneClickAlarmHandling',
    method: 'post',
    data
  })
}
